<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="3" md="3" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="as_on.value.value"
                        label="Date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        bg-color="grey-lighten-4"
                        autocomplete="off"
                        hide-details
                      />
                    </v-col>

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Customer"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="customer_id.value.value"
                        :items="getCustomerList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        autocomplete="off"
                        clearable
                      
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Sales Accounts Receivable Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="px-2 pt-4 pb-0">
                  <v-col md="3" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema?.rows"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:body.append>
                    <tr class="font-weight-bold bg-grey-lighten-4">
                      <td></td>
                      <td class="text-end">Total</td>
                      <td class="text-right">{{ totals.days_0_60 }}</td>
                      <td class="text-center">{{ totals.days_61_90 }}</td>
                      <td class="text-center">{{ totals.days_91_120 }}</td>
                      <td class="text-center">{{ totals.days_121_150 }}</td>
                      <td class="text-center">{{ totals.days_over_120 }}</td>
                      <td class="text-center">{{ totals.days_over_150 }}</td>
                      <td class="text-center">{{ totals.amount }}</td>
                      <td class="text-center">{{ totals.percentage }}</td>
                      <td class="text-center"></td>
                    </tr>
                  </template>

                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "100px", sortable: false },
      { title: "Customer Name", key: "customer_name", align: "left", sortable: false, width: "350px" },
      { title: "0-60 Days", key: "aging.days_0_60", align: "right", sortable: false },
      { title: "61-90 Days", key: "aging.days_61_90", align: "center", sortable: false },
      { title: "90-120 Days", key: "aging.days_91_120", align: "center", sortable: false },
      { title: "121-150 Days", key: "aging.days_121_150", align: "center", sortable: false },
      // { title: ">120 Days", key: "aging.days_over_120", align: "center", sortable: false },
      { title: ">151 Days", key: "aging.days_over_150", align: "center", sortable: false },
      { title: "Amount", key: "amount", align: "center", sortable: false },
      { title: "%", key: "percentage", align: "center", sortable: false },
      { title: "Reff.", key: "reference", align: "center", sortable: false },
    ],
  }),
  watch: {},
  created() {

    const promises = [];

    // if (this.$store.getters.getCustomerList.length == 0) {
      promises.push(this.$store.dispatch("getCustomerList"));
    // }
    
  },
  computed: {
    getSchema() {
      return this.$store.getters.getSalesAcountsReceivableAging;
    },
    getCustomerList() {
      let data = this.$store.getters.getCustomerList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
    totals() {
      const rows = this.getSchema?.summary || [];
      return {
        days_0_60: rows?.days_0_60,
        days_61_90: rows?.days_61_90,
        days_91_120: rows?.days_91_120,
        days_121_150: rows?.days_121_150,
        days_over_120: rows?.days_over_120,
        days_over_150: rows?.days_over_150,
        amount: rows?.total_receivable,
        percentage: rows?.percentage,
      }
      
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // Add validation if needed
        // customer_id: yup.string().nullable().label('Employee'),
        // category: yup.number().positive().integer().nullable().label('Category'),
        // sub_category: yup.number().positive().integer().nullable().label('Sub Category'),
      }),
    });

    const customer_id = useField("customer_id");
    const as_on = useField("as_on");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const submit = handleSubmit((values) => {
      values.as_on = formattedDate(as_on.value.value)
      loading.value = true;
      store
        .dispatch("getSalesAcountsReceivableAging", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          loading.value = false;
          toast.error(error.response.data.message);
        });
    });

    return {
      as_on,
      customer_id,
      submit,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$store.commit("setEditingProduct", item);
      this.$router.push({ name: "add-product", query: {id: item.id} });
    },

    exportToPDF() {
      let serialNumber = 1;

      const columns = [
        "#SL",
        "Customer Name",
        "0-60 Days",
        "61-90 Days",
        "91-120 Days",
        "121-150 Days",
        ">120 Days",
        ">151 Days",
        "Amount",
        "%",
        "Reference",
      ];

      const rows = this.getSchema.rows.map((item) => [
        serialNumber++,
        item.customer_name,
        item.aging?.days_0_60 ?? 0,
        item.aging?.days_61_90 ?? 0,
        item.aging?.days_91_120 ?? 0,
        item.aging?.days_121_150 ?? 0,
        item.aging?.days_over_120 ?? 0,
        item.aging?.days_over_150 ?? 0,
        item.amount,
        item.percentage,
        item.reference,
      ]);

      rows.push([
        "",
        "Total",
        this.totals.days_0_60,
        this.totals.days_61_90,
        this.totals.days_91_120,
        this.totals.days_121_150,
        this.totals.days_over_120,
        this.totals.days_over_150,
        this.totals.amount,
        this.totals.percentage,
        "",
      ]);

      this.$exportTableToPDF(
        columns,
        rows,
        "Sales Accounts Receivable Aging Report",
        "sales_accounts_receivable_aging_" + this.$fileDate()
      );
    },
    exportToExcel() {
      const data = [[
        "#SL",
        "Customer Name",
        "0-60 Days",
        "61-90 Days",
        "91-120 Days",
        "121-150 Days",
        ">120 Days",
        ">151 Days",
        "Amount",
        "%",
        "Reference",
      ]];

      let serialNumber = 1;

      this.getSchema.rows.forEach((item) => {
        data.push([
          serialNumber++,
          item.customer_name,
          item.aging?.days_0_60 ?? 0,
          item.aging?.days_61_90 ?? 0,
          item.aging?.days_91_120 ?? 0,
          item.aging?.days_121_150 ?? 0,
          item.aging?.days_over_120 ?? 0,
          item.aging?.days_over_150 ?? 0,
          item.amount,
          item.percentage,
          item.reference,
        ]);
      });

      data.push([
        "",
        "Total",
        this.totals.days_0_60,
        this.totals.days_61_90,
        this.totals.days_91_120,
        this.totals.days_121_150,
        this.totals.days_over_120,
        this.totals.days_over_150,
        this.totals.amount,
        this.totals.percentage,
        "",
      ]);

      this.$exportTableToExcel(
        data,
        "sales_accounts_receivable_aging_" + this.$fileDate()
      );
    },
    exportToCSV() {
      const data = [[
        "#SL",
        "Customer Name",
        "0-60 Days",
        "61-90 Days",
        "91-120 Days",
        "121-150 Days",
        ">120 Days",
        ">151 Days",
        "Amount",
        "%",
        "Reference",
      ]];

      let serialNumber = 1;

      this.getSchema.rows.forEach((item) => {
        data.push([
          serialNumber++,
          item.customer_name,
          item.aging?.days_0_60 ?? 0,
          item.aging?.days_61_90 ?? 0,
          item.aging?.days_91_120 ?? 0,
          item.aging?.days_121_150 ?? 0,
          item.aging?.days_over_120 ?? 0,
          item.aging?.days_over_150 ?? 0,
          item.amount,
          item.percentage,
          item.reference,
        ]);
      });

      data.push([
        "",
        "Total",
        this.totals.days_0_60,
        this.totals.days_61_90,
        this.totals.days_91_120,
        this.totals.days_121_150,
        this.totals.days_over_120,
        this.totals.days_over_150,
        this.totals.amount,
        this.totals.percentage,
        "",
      ]);

      this.$exportTableToCSV(
        data,
        "sales_accounts_receivable_aging_" + this.$fileDate()
      );
    },
  },  
  mounted() {
    // Auto-trigger search on mount like the requisition list
    // this.$nextTick(() => {
    //   this.$refs.searchButton.$el.click();
    // });   
  },
};
</script>